import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "hardware-warning-zone-body" }

import { computed, onMounted, reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import Card from '@/views/dashboard/_components/card/card.vue'
import HardwareMonitorStatCard from '@/views/dashboard/_components/hardware-monitor-stat-card/hardware-monitor-stat-card.vue'
import { HomeService,  HomeData } from '@/views/dashboard/home/home.service'
import  { HardwareWarningItem } from '../types'


export default /*#__PURE__*/_defineComponent({
  __name: 'hardware-warning-zone',
  setup(__props) {

const { t, locale } = useI18n()
const router = useRouter()
const injector = useReflectiveInjector([HomeService])
const homeService = injector.get(HomeService)

const loading = ref(false)

const homePayload = reactive({
  safe_stat: {} as HomeData['safe_stat'],
  team_stat: { total: 0, online_count: 0, offline_count: 0 } as HomeData['team_stat']
})

const totalTerminals = computed(() => homePayload.team_stat?.total || 0)

function statPair(count: number): { count: number; percent: number } {
  const c = count || 0
  const total = homePayload.team_stat?.total || 0
  const percent = total > 0 ? Math.min(100, Math.round((c / total) * 100)) : 0
  return { count: c, percent }
}

/** 与 device-status 页顶部监控卡同源：/terminal/static 的 safe_stat + team_stat */
const warningData = computed<HardwareWarningItem[]>(() => {
  void locale.value
  const safe = homePayload.safe_stat || ({} as HomeData['safe_stat'])
  return [
    {
      category: t('deviceStatus.memoryMonitor'),
      warnings: [
        { label: t('deviceStatus.cpuTooHigh'), count: statPair(safe.high_cpu_load).count },
        { label: t('deviceStatus.memoryTooHigh'), count: statPair(safe.high_dick_load).count }
      ]
    },
    {
      category: t('deviceStatus.storageMonitor'),
      warnings: [
        { label: t('deviceStatus.systemDiskTooHigh'), count: statPair(safe.high_proportion_system_disk).count },
        { label: t('deviceStatus.wholeDiskTooHigh'), count: statPair(safe.high_proportion_disk).count }
      ]
    },
    {
      category: t('deviceStatus.networkSpeedUsage'),
      warnings: [
        { label: t('deviceStatus.uploadSpeedTooHigh'), count: statPair(safe.high_upload).count },
        { label: t('deviceStatus.downloadSpeedTooHigh'), count: statPair(safe.high_download).count }
      ]
    },
    {
      category: t('deviceStatus.tempMonitor'),
      warnings: [
        { label: t('deviceStatus.cpuTempTooHigh'), count: statPair(safe.high_cpu_temperature).count },
        { label: t('deviceStatus.diskTempTooHigh'), count: statPair(safe.high_disk_temperature).count }
      ]
    }
  ]
})

function warningItemsFor(group: HardwareWarningItem) {
  const total = totalTerminals.value || 0
  return group.warnings.map(w => ({
    label: w.label,
    count: w.count,
    percent: total > 0 ? Math.min(100, (w.count / total) * 100) : 0
  }))
}

function loadHardwareStatic() {
  loading.value = true
  homeService
    .getData()
    .then(res => {
      homePayload.safe_stat = res.safe_stat || ({} as HomeData['safe_stat'])
      homePayload.team_stat = res.team_stat || { total: 0, online_count: 0, offline_count: 0 }
    })
    .finally(() => {
      loading.value = false
    })
}

function handleViewMore() {
  router.push('/dashboard/device-status')
}

onMounted(() => {
  loadHardwareStatic()
})

return (_ctx: any,_cache: any) => {
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(Card, {
    size: "second",
    title: _ctx.$t('overviewZone.hardwareWarningTitle'),
    description: _ctx.$t('overviewZone.hardwareWarningDesc', { total: totalTerminals.value }),
    style: {"height":"100%"},
    "on-view-more": handleViewMore
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_row, { style: {"display":"grid","grid-template-columns":"repeat(2, 1fr)","gap":"15px"} }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(warningData.value, (warning, index) => {
              return (_openBlock(), _createBlock(HardwareMonitorStatCard, {
                key: index,
                title: warning.category,
                items: warningItemsFor(warning)
              }, null, 8, ["title", "items"]))
            }), 128))
          ]),
          _: 1
        })
      ])), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["title", "description"]))
}
}

})